import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  formatBytes,
  getFileExtension,
  readPDFFile,
  renderPDFPage,
  saveFile,
  readPDFFileAsArrayBuffer,
  readEncryptedPDFFileAsArrayBuffer,
} from "../Utils";

import { PDFDocument } from "pdf-lib-plus-encrypt";
import { encryptPDF } from "../PDFHelper/PDFRenderer";
import PDFViewerView from "../pdf_viewer/PDFViewerView";

function LockPDFImageListScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, page count etc key is filepath
  const [filesInfo, setFilesInfo] = useState({});
  //item displaying in password input modal
  const [selectedItemForPasswordInput, setSelectedItemForPasswordInput] =
    useState(null);
  //export configuration
  const [exportConfiguration, setExportConfiguration] = useState({
    password: "",
    printable: false,
    cancopy: false,
  });
  //password input modal input field reference
  //get password value
  const passwordInputModalInputRef = useRef(null);
  //is locking
  const [isLocking, setIsLocking] = useState(false);

  //show pdf preview
  const [showPDFPreview, setShowPDFPreview] = useState({
    preview: false,
    file: null,
    password: "",
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //generate thumbnails
      generateThumbnails();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const generateThumbnails = async () => {
    //loop
    //read files
    //get thumbnails
    for (let i = 0; i < selectedFiles.length; i++) {
      //process pdf file
      processPDFFile(selectedFiles[i], "");
    }
  };

  //fetch pdf file as data
  //get thumbnail
  //chek if password protected
  //unlock if provided correct password
  //render file
  const processPDFFile = async (selectedFile, password) => {
    //get image
    pdfThumbnail(selectedFile, password);
  };

  //pdf thumbnail
  const pdfThumbnail = async (selectedFile, password) => {
    //read pdf file
    await readPDFFile(selectedFile)
      .then(async (data) => {
        //path pdf file
        const key = String(selectedFile.path);
        //thumbnail
        await renderPDFPage(data, password, "image/jpeg", 0.2, 0)
          .then(([img, numPages]) => {
            //set image
            setFilesInfo((prevDictionary) => ({
              ...prevDictionary,
              [key]: {
                ...filesInfo[key],
                state: AppState.LOADED,
                thumbnail: img,
                pageCount: numPages,
                message:
                  numPages > 100
                    ? "Note: Too many pages in this pdf file. To protect your privacy our app runs entirely offline, so your device must have enough memory available to convert this file successfully."
                    : "",
                locked: false,
                password: password,
                name: selectedFile.name,
                file: selectedFile, //selected file
                size: selectedFile.size, //in bytes
                locked_blob: null,
                locked_size: 0,
              },
            }));
          })
          .catch((e) => {
            //check
            if (e.name === "PasswordException") {
              //set message string
              setFilesInfo((prevDictionary) => ({
                ...prevDictionary,
                [key]: {
                  ...filesInfo[key],
                  state: AppState.LOADED,
                  message: "",
                  locked: true,
                  password: "",
                  name: selectedFile.name,
                  file: selectedFile, //selected file
                  size: selectedFile.size, //in bytes
                  locked_blob: null,
                  locked_size: 0,
                },
              }));
            } else {
              //set message string
              setFilesInfo((prevDictionary) => ({
                ...prevDictionary,
                [key]: {
                  ...filesInfo[key],
                  state: AppState.NONE,
                  message: "Can not load file. Something went wrong.",
                  locked: false,
                  password: "",
                  name: selectedFile.name,
                  file: selectedFile, //selected file
                  size: selectedFile.size, //in bytes
                  locked_blob: null,
                  locked_size: 0,
                },
              }));
            }
          });
      })
      .catch((e) => {
        console.log("Error: ", e);
      });
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setExportConfiguration({
      password: "",
      printable: false,
      cancopy: false,
    });
    setFilesInfo({});
    setStartProcessingFiles(false);
  };

  //render password input modal
  const renderPassordInputModal = (item) => {
    return (
      <div
        className="modal fade"
        id="passwordInputModal"
        tabIndex="-1"
        aria-labelledby="passwordInputModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="passwordInputModalLabel">
                {item !== null ? item.name : "Failed loading file"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="password" className="col-form-label">
                    Unlock pdf to continue. Enter password below:
                  </label>
                  <input
                    type="password"
                    className="form-control mt-2"
                    id="password"
                    placeholder="Type password here..."
                    ref={passwordInputModalInputRef}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //process pdf file with password
                  processPDFFile(
                    item,
                    passwordInputModalInputRef.current.value,
                  );
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Unlock
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        data-bs-toggle={`${
          String(item.path) in filesInfo
            ? filesInfo[String(item.path)].locked
              ? "modal"
              : ""
            : ""
        }`}
        data-bs-target={`${
          String(item.path) in filesInfo
            ? filesInfo[String(item.path)].locked
              ? "#passwordInputModal"
              : ""
            : ""
        }`}
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //check
          if (String(item.path) in filesInfo === true) {
            //if locked
            if (filesInfo[String(item.path)].locked === true) {
              //show password field
              //set item
              setSelectedItemForPasswordInput(item);
            } else {
              //set preview
              setShowPDFPreview({
                ...showPDFPreview,
                preview: true,
                file: filesInfo[String(item.path)].file,
                password: filesInfo[String(item.path)].password,
              });
            }
          }
        }}
      >
        {/* Flex container left image pdf right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].thumbnail != null
                      ? filesInfo[String(item.path)].thumbnail
                      : "./images/file_icon.png"
                    : "./images/file_icon.png"
                }
                alt="pdf_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size:{" "}
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? formatBytes(filesInfo[String(item.path)].locked_size)
                    : formatBytes(item.size)
                  : formatBytes(0)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].state === AppState.PROCESSED
                      ? "text-success"
                      : "bg-danger text-white"
                    : "bg-danger text-white"
                }`}
              >
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? "LOCKED"
                    : getFileExtension(item.name.toUpperCase())
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Page Count */}
            <div className="px-2 fs-6 text-body-secondary">
              {String(item.path) in filesInfo
                ? (filesInfo[String(item.path)].pageCount === undefined
                    ? "__"
                    : filesInfo[String(item.path)].pageCount) + " Pages"
                : "0 Pages"}
            </div>
            {/* Lock Message */}
            <div
              className={`px-2 text-danger fs-6 mt-3 fw-bold ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].locked
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              Locked. Click to unlock.
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].message !== ""
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {String(item.path) in filesInfo
                ? filesInfo[String(item.path)].message
                : ""}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          {/* Download Button */}
          {/* Show download button after processed */}
          <div
            className="position-absolute  justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={async (e) => {
                  //stop propagating
                  e.stopPropagation();
                  //check
                  if (String(item.path) in filesInfo === true) {
                    //blob
                    const blob = filesInfo[String(item.path)].locked_blob;
                    //save
                    await saveFile(blob, filesInfo[String(item.path)].name);
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
              </button>
            </div>
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSING
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.LOADED ||
                    filesInfo[String(item.path)].state === AppState.NONE
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setFilesInfo((currentData) => {
                    // Destructure the key to remove into a throwaway variable (e.g., '_')
                    // and collect the rest of the properties into a new object 'rest'
                    const { [String(item.path)]: _, ...rest } = currentData;
                    //return
                    return rest;
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  //on  password value changed
  const onPasswordValueChanged = (e) => {
    //set values
    setExportConfiguration({
      ...exportConfiguration,
      password: e.target.value,
    });
  };

  //on change print checkbox values
  const onChangePrintCheckboxValues = (e) => {
    //set
    setExportConfiguration({
      ...exportConfiguration,
      printable: e.target.checked,
    });
  };

  //on change copy checkbox values
  const onChangeCopyCheckboxValues = (e) => {
    //set
    setExportConfiguration({
      ...exportConfiguration,
      cancopy: e.target.checked,
    });
  };

  return (
    //show hide loading view
    <div className="position-relative">
      {/* show pdf preview */}
      {/* page main content */}
      {showPDFPreview.preview ? (
        <PDFViewerView
          title={showPDFPreview.file === null ? "" : showPDFPreview.file.name}
          password={showPDFPreview.password}
          onClose={() => {
            //set preview
            setShowPDFPreview({
              ...showPDFPreview,
              preview: false,
              file: null,
              password: "",
            });
          }}
          file={showPDFPreview.file}
        ></PDFViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Lock Pdf files"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1 border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Label */}
              <label
                htmlFor="password"
                className="form-label mt-5 ms-4 me-4 fs-4 text-dark"
                data-toggle="tooltip"
                data-placement="top"
                title="Enter password to encrypt selected documents"
              >
                Encryption Details:
              </label>
              <input
                type="password"
                className="form-control ms-4 mt-3 me-4"
                id="passwordInput"
                aria-describedby="password"
                placeholder="Enter password"
                onChange={onPasswordValueChanged}
                style={{ width: "calc(100% - 48px)" }}
              />

              {/* Additional settings */}
              <div className="w-100 ms-4 mt-5 border-top pt-3">
                <label className="fs-4 me-4">Additional Settings:</label>
                {/* Checkbox Printable */}
                <div className="form-check mt-4">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    checked={exportConfiguration.printable}
                    id="printable"
                    onChange={onChangePrintCheckboxValues}
                  />
                  <label className="form-check-label ms-2" htmlFor="printable">
                    Printable
                  </label>
                </div>
                {/* Checkbox Copy */}
                <div className="form-check mt-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    checked={exportConfiguration.cancopy}
                    id="copy"
                    onChange={onChangeCopyCheckboxValues}
                  />
                  <label className="form-check-label ms-2" htmlFor="copy">
                    Can Copy
                  </label>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isLocking ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                }}
                type="button"
                onClick={async (e) => {
                  //set
                  setIsLocking(true);
                  //loop
                  for (let i = 0; i < selectedFiles.length; i++) {
                    //selected file
                    const selectedFile = selectedFiles[i];
                    //key
                    const key = String(selectedFile.path);
                    //check
                    if (key in filesInfo === false) {
                      //continue
                      continue;
                    }

                    //doc info
                    const docInfo = filesInfo[key];

                    //lock unencrypted pdfs directly using pdf-lib
                    //for encrypted pdfs expract images then lock using pdf-lib
                    try {
                      //read pdf file
                      let data = await readPDFFileAsArrayBuffer(selectedFile);
                      //set state
                      setFilesInfo((prevDictionary) => ({
                        ...prevDictionary,
                        [key]: {
                          ...filesInfo[key],
                          state: AppState.PROCESSING,
                          message: `Reading file...`,
                        },
                      }));
                      // Load a PDF with form fields
                      //if encrypted
                      //proceed to ctch block
                      const pdfDoc = await PDFDocument.load(data);

                      //set
                      //set blob
                      setFilesInfo((prevDictionary) => ({
                        ...prevDictionary,
                        [key]: {
                          ...filesInfo[key],
                          state: AppState.PROCESSING,
                          message: `Encrypting file...`,
                        },
                      }));

                      //encrypt pdf
                      await encryptPDF(
                        "Locked PDF",
                        pdfDoc,
                        exportConfiguration.password,
                        {
                          printable: exportConfiguration.printable,
                          cancopy: exportConfiguration.cancopy,
                        },
                        (blob) => {
                          //set
                          //set blob
                          setFilesInfo((prevDictionary) => ({
                            ...prevDictionary,
                            [key]: {
                              ...filesInfo[key],
                              state: AppState.PROCESSED,
                              message: `Successfully locked pdf document. Click on download button to save.`,
                              locked_blob: blob === null ? selectedFile : blob,
                              locked_size:
                                blob === null ? selectedFile.size : blob.size,
                            },
                          }));
                        },
                      );
                    } catch (e) {
                      //decrypy pdf using pdfjsLib
                      //read pdf file
                      //as pdf-lib does not decrypt encrypted we need pdfjslib to decrypt it
                      let data = await readEncryptedPDFFileAsArrayBuffer(
                        selectedFile,
                        docInfo.password,
                        (perct) => {
                          //set state
                          setFilesInfo((prevDictionary) => ({
                            ...prevDictionary,
                            [key]: {
                              ...filesInfo[key],
                              state: AppState.PROCESSING,
                              message: `Extracted ${Math.floor(perct * 100)}%`,
                            },
                          }));
                        },
                      );
                      //check
                      if (data === null) {
                        //set
                        //set blob
                        setFilesInfo((prevDictionary) => ({
                          ...prevDictionary,
                          [key]: {
                            ...filesInfo[key],
                            state: AppState.PROCESSED,
                            message: `Failed processing file.`,
                          },
                        }));
                        //cotinue
                        continue;
                      }

                      //set state
                      setFilesInfo((prevDictionary) => ({
                        ...prevDictionary,
                        [key]: {
                          ...filesInfo[key],
                          state: AppState.PROCESSING,
                          message: `Reading file...`,
                        },
                      }));
                      // Load a PDF with form fields
                      //if encrypted
                      //proceed to ctch block
                      const pdfDoc = await PDFDocument.load(data);
                      //set state
                      setFilesInfo((prevDictionary) => ({
                        ...prevDictionary,
                        [key]: {
                          ...filesInfo[key],
                          state: AppState.PROCESSING,
                          message: `Encrypting file...`,
                        },
                      }));

                      //encrypt pdf
                      await encryptPDF(
                        "Locked PDF",
                        pdfDoc,
                        exportConfiguration.password,
                        {
                          printable: exportConfiguration.printable,
                          cancopy: exportConfiguration.cancopy,
                        },
                        (blob) => {
                          //set
                          //set blob
                          setFilesInfo((prevDictionary) => ({
                            ...prevDictionary,
                            [key]: {
                              ...filesInfo[key],
                              state: AppState.PROCESSED,
                              message: `Successfully locked pdf document. Click on download button to save.`,
                              locked_blob: blob === null ? selectedFile : blob,
                              locked_size:
                                blob === null ? selectedFile.size : blob.size,
                            },
                          }));
                        },
                      );
                    }
                  }
                  //reset
                  setIsLocking(false);
                }}
              >
                LOCK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Password input modal */}
      {renderPassordInputModal(selectedItemForPasswordInput)}
    </div>
  );
}

export default LockPDFImageListScreen;
